// import Image from 'next/image';
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react'; // Import Swiper and SwiperSlide
import 'swiper/css'; // Import Swiper core styles
import 'swiper/css/navigation'; // Import Swiper navigation styles
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { useTranslation,Trans  } from 'react-i18next';
import axios from "axios";
import { API_URL } from "../../Constants";

const Experience = () => {
    const { t } = useTranslation();
    const [myCommunity, setCommunity] = useState([]);

    useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get(`${API_URL}/grsfAPI/getTransCommImages`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })

            .then((res) => {
                setCommunity(res.data.community)
                // console.log("Mycommunity==========>", res.data.community);
            })
            .catch((err) => {
                console.error("Error fetching data:", err);
            });


        const container = document.querySelector(".container");
        const target = document.querySelector(".left-box-padding");

        if (container && target) {
            // Get the computed margin-right of the container
            const containerStyle = getComputedStyle(container);
            const marginRight = containerStyle.marginRight;

            // Set the custom CSS variable on the target element
            target.style.setProperty("--custom-left", marginRight);
            // console.log(`Margin-Right: ${marginRight}`);
        }

    }, [])


    return (
        <section className="lyt-section overflow-hidden mb40">
            <div className="typ-community-lyt">
                <div className="row typ-align-center left-box-padding">
                    <div className="col-lg-4 col-md-4 col-12">
                        <div className="">
                            <div className='typ-mb-45'>
                                <h4 className="bs-heading typwhite typ-mb12">{t('experienceTitle')}</h4>
                                <p className="bs-para typ-16 typ-mb48 typoffwhite">{t('experienceSubTitle')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-8 col-md-8 col-12">
                        <div className="bs-swiper typ-community-swiper">

                            <Swiper
                                modules={[Navigation, Autoplay]}
                                spaceBetween={15}
                                slidesPerView={3}
                                centeredSlides={true}
                                loop={true}
                                autoplay={{
                                    delay: 3000,
                                    disableOnInteraction: false,
                                }}
                                navigation={{
                                    prevEl: ".previous",
                                    nextEl: ".next",
                                }}
                                breakpoints={{
                                    320: {
                                        slidesPerView: 1,
                                    },
                                    768: {
                                        slidesPerView: 2,
                                    },
                                    1024: {
                                        slidesPerView: 2.8,
                                        spaceBetween: 5,
                                    },
                                }}
                                className="swiper-container"
                            >

                                {myCommunity.map((item, index) => {
                                    const { ourCommunityImgUrl } = item;

                                    return (
                                        <SwiperSlide key={index}>
                                            <div className='img-wrapper'>
                                                <img
                                                    className="img-fluid"
                                                    src={item.ourCommunityImgUrl}
                                                    alt="logo"
                                                    width={280}
                                                    height={350}
                                                />
                                            </div>
                                        </SwiperSlide>
                                    )
                                })}
                            </Swiper>

                            <div className="swiper-button-prev previous">
                                <span className="icon icon-right-arrow"></span>
                            </div>
                            <div className="swiper-button-next next">
                                <span className="icon icon-right-arrow"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Experience;
